import { render, staticRenderFns } from "./PublicRanking.vue?vue&type=template&id=9ec6b32e&scoped=true"
import script from "./PublicRanking.vue?vue&type=script&lang=js"
export * from "./PublicRanking.vue?vue&type=script&lang=js"
import style0 from "./PublicRanking.vue?vue&type=style&index=0&id=9ec6b32e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec6b32e",
  null
  
)

export default component.exports